"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SelectCheckbox = ({ id, type, name, handleClick, isChecked }) => {
    return (react_1.default.createElement("input", { id: id, name: name, type: type, onChange: handleClick, checked: isChecked, className: 'checkboxx cursor-pointer' }));
};
exports.default = SelectCheckbox;
